import { render } from "./Dashboard.vue?vue&type=template&id=ce78cf6a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=ce78cf6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce78cf6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce78cf6a', __exports__)) {
    api.reload('ce78cf6a', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=ce78cf6a", () => {
    api.rerender('ce78cf6a', render)
  })

}


export default __exports__